import { List, Map } from 'immutable';
import { myRemoveEntitiesBySport } from './utils';
import { LIVE_INIT, LIVE_UPDATE, LIVE_MATCH_INIT, LIVE_MATCH_UPDATE, TIMETABLE_INIT, TIMETABLE_UPDATE } from '../../sagas/actions';
import * as PopularActions from '../../actions/popular';
import * as LineActions from '../../actions/lines';
import * as MatchResultsAction from '../../actions/matchResults';
import * as LiveActions from '../../actions/live';
export default function sportsReducer(sports, action) {
    switch (action.type) {
        case PopularActions.CLEAR_POPULAR:
        case LineActions.CLEAR_LINE:
        case MatchResultsAction.CLEAR_MATCH_RESULTS:
        case MatchResultsAction.FETCH_MATCH_RESULTS:
        case LiveActions.CLEAR_LIVE:
        case LiveActions.CLEAR_LIVE_MATCH:
            return Map();
        case LIVE_INIT.SUCCESS:
        case LIVE_MATCH_INIT.SUCCESS:
        case TIMETABLE_INIT.SUCCESS:
        case LineActions.SUCCESS_FETCH_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_SPORT_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_LEAGUE_LINE_HEADERS:
        case LineActions.SUCCESS_FETCH_FULL_LINE:
        case PopularActions.SUCCESS_FETCH_POPULAR_MATCHES:
        case MatchResultsAction.SUCCESS_FETCH_MATCH_RESULTS:
            return init(new Map(), action.data);
        case LIVE_UPDATE.SUCCESS:
        case LIVE_MATCH_UPDATE.SUCCESS:
        case TIMETABLE_UPDATE.SUCCESS:
            return update(sports, action.data);
    }
    return sports;
}
function init(sports, data) {
    if (data.sports !== undefined) {
        sports = addSports(sports, data.sports.add);
    }
    if (data.leagues !== undefined) {
        sports = addSportsLeagues(sports, data.leagues.add);
    }
    if (data.events !== undefined) {
        sports = addSportsMatches(sports, data.events.add);
    }
    return sports;
}
function update(sports, data) {
    if (data.sports !== undefined) {
        sports = myRemoveEntitiesBySport(sports, 'id', data.sports.remove);
        sports = addSports(sports, data.sports.add);
        sports = changeSports(sports, data.sports.change);
    }
    if (data.leagues !== undefined) {
        sports = myRemoveSportLeagues(sports, data.leagues.remove);
        sports = addSportsLeagues(sports, data.leagues.add);
    }
    if (data.events !== undefined) {
        sports = myRemoveSportMatches(sports, data.events.remove);
        sports = addSportsMatches(sports, data.events.add);
    }
    return sports;
}
function addSports(sports, addSports) {
    if (addSports === undefined) {
        return sports;
    }
    sports = sports.withMutations(function (s) {
        for (var i = 0; i < addSports.length; i++) {
            var sport = new Map(addSports[i]);
            sport = sport.set('leagues', new List());
            sport = sport.set('leagueMatches', new Map());
            s.set(sport.get('id'), sport);
        }
    });
    return sports;
}
function changeSports(sports, changedSports) {
    if (changedSports === undefined) {
        return sports;
    }
    var _loop_1 = function (i) {
        var sport = changedSports[i];
        sports = sports.updateIn([sport.id, 'name'], function () { return sport.name; });
        sports = sports.updateIn([sport.id, 'priority'], function () { return sport.priority; });
    };
    for (var i = 0; i < changedSports.length; i++) {
        _loop_1(i);
    }
    return sports;
}
function addSportsLeagues(sports, addLeagues) {
    if (addLeagues === undefined) {
        return sports;
    }
    for (var i = 0; i < addLeagues.length; i++) {
        var sportId = addLeagues[i].sportId;
        var leagueId = addLeagues[i].id;
        (function (sportId, leagueId) {
            sports = sports.updateIn([sportId, 'leagues'], function (l) { return l.push(leagueId); });
            sports = sports.updateIn([sportId, 'leagueMatches'], function (l) { return l.set(leagueId, List()); });
        })(sportId, leagueId);
    }
    return sports;
}
function addSportsMatches(sports, addMatches) {
    if (addMatches === undefined) {
        return sports;
    }
    for (var i = 0; i < addMatches.length; i++) {
        var sportId = addMatches[i].sportId;
        var leagueId = addMatches[i].leagueId;
        var matchId = addMatches[i].id;
        (function (sportId, leagueId, matchId) {
            sports = sports.updateIn([sportId, 'leagueMatches', leagueId], function (l) { return l.push(matchId); });
        })(sportId, leagueId, matchId);
    }
    return sports;
}
function myRemoveSportLeagues(sports, removeLeagues) {
    if (removeLeagues === undefined) {
        return sports;
    }
    var _loop_2 = function (i) {
        var sportId = removeLeagues[i].sportId;
        var leagueId = removeLeagues[i].id;
        var leagues = sports.getIn([sportId, 'leagues']);
        if (leagues !== undefined) {
            leagues = leagues.filter(function (lId) { return (lId != leagueId); });
        }
        sports = sports.setIn([sportId, 'leagues'], leagues);
        var leagueMatches = sports.getIn([sportId, 'leagueMatches']);
        if (leagueMatches !== undefined) {
            leagueMatches = leagueMatches.filter(function (matches, lId) { return (lId != leagueId); });
        }
        sports = sports.setIn([sportId, 'leagueMatches'], leagueMatches);
    };
    for (var i = 0; i < removeLeagues.length; i++) {
        _loop_2(i);
    }
    return sports;
}
function myRemoveSportMatches(sports, removeMatches) {
    if (removeMatches === undefined) {
        return sports;
    }
    var _loop_3 = function (i) {
        var sportId = removeMatches[i].sportId;
        var leagueId = removeMatches[i].leagueId;
        var matchId = removeMatches[i].id;
        var matches = sports.getIn([sportId, 'leagueMatches', leagueId]);
        if (matches !== undefined) {
            matches = matches.filter(function (mId) { return (mId != matchId); });
        }
        sports = sports.setIn([sportId, 'leagueMatches', leagueId], matches);
    };
    for (var i = 0; i < removeMatches.length; i++) {
        _loop_3(i);
    }
    return sports;
}



// WEBPACK FOOTER //
// ./src/reducers/entities/sportsReducer.js